import { FETCH_LOAN_DATA } from '../types'
export default (state = [], action) => {
  switch (action.type) {
    case FETCH_LOAN_DATA:
      return action.payload
    default:
      return state;
  }
}